var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountTransferCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 15C13.8987 15 15.8574 13.0412 15.8574 10.625C15.8574 8.20875 13.8987 6.25 11.4824 6.25C9.06618 6.25 7.10742 8.20875 7.10742 10.625C7.10742 13.0412 9.06618 15 11.4824 15Z",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46094 19.3061C5.11928 18.0094 6.12383 16.9203 7.36325 16.1595C8.60267 15.3988 10.0285 14.9961 11.4828 14.9961C12.9371 14.9961 14.363 15.3988 15.6024 16.1595C16.8418 16.9203 17.8463 18.0094 18.5047 19.3061",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.501 1.76904L21.2133 5.48135",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2139 1.76904L17.5016 5.48135",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.837 9.75004C22.2062 11.9434 21.8687 14.1973 20.8733 16.1863C19.8779 18.1754 18.2762 19.7966 16.2993 20.8159C14.3224 21.8352 12.0727 22.1999 9.8751 21.8573C7.67746 21.5146 5.64557 20.4824 4.07283 18.9097C2.50009 17.337 1.46788 15.3051 1.12524 13.1074C0.782609 10.9098 1.14728 8.66011 2.1666 6.68324C3.18593 4.70637 4.80715 3.1046 6.79618 2.10923C8.78522 1.11385 11.0391 0.776368 13.2325 1.14551",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTransferCrossIcon);
export default __webpack_public_path__ + "static/media/AccountTransferCrossIcon.64d61427045c8384b3f3e28e759eb994.svg";
export { ForwardRef as ReactComponent };